export enum OfferServiceTypeEnum {
  LTL = 'LTL',
  FTL = 'FTL',
  QUOTATION = 'QUOTATION',
}
